import React, { useState } from 'react';

const FONT = '"Nunito", "Baloo 2", sans-serif';

/** G5: Scrambled letters → unscramble to spell the word */
export default function WordScramble({ roundData, onAnswer, palette: P, disabled }) {
  const prompt = roundData.prompt || {};
  const answer = roundData.answer_key || '';
  const [selectedLetters, setSelectedLetters] = useState([]);
  const [availableIndices, setAvailableIndices] = useState(
    () => (prompt.scrambled || []).map((_, i) => i)
  );
  const [showResult, setShowResult] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);

  const handleLetterClick = (poolIdx) => {
    if (disabled || showResult) return;
    const letter = prompt.scrambled[poolIdx];
    const newSelected = [...selectedLetters, { letter, poolIdx }];
    setSelectedLetters(newSelected);
    setAvailableIndices(availableIndices.filter(i => i !== poolIdx));

    // Check if word is complete
    const typed = newSelected.map(s => s.letter).join('');
    if (typed.length >= answer.length) {
      const correct = typed.toLowerCase() === answer.toLowerCase();
      setIsCorrect(correct);
      setShowResult(true);
      setTimeout(() => onAnswer(correct, typed), correct ? 700 : 1100);
    }
  };

  const handleRemoveLast = () => {
    if (disabled || showResult || selectedLetters.length === 0) return;
    const last = selectedLetters[selectedLetters.length - 1];
    setSelectedLetters(selectedLetters.slice(0, -1));
    setAvailableIndices([...availableIndices, last.poolIdx].sort((a, b) => a - b));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20, width: '100%', maxWidth: 480, margin: '0 auto', fontFamily: FONT }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: P.mutedText }}>
        Xếp chữ cái thành từ đúng
      </div>
      {prompt.hint_vi && (
        <div style={{
          fontSize: 22, fontWeight: 800, color: P.coral,
          background: P.sand, padding: '8px 20px', borderRadius: 12,
          border: `2px solid ${P.ink}`,
        }}>
          {prompt.hint_vi}
        </div>
      )}

      {/* Answer slots */}
      <div style={{ display: 'flex', gap: 6, minHeight: 50 }} onClick={handleRemoveLast}>
        {Array.from({ length: answer.length }).map((_, i) => {
          const letter = selectedLetters[i]?.letter || '';
          return (
            <div key={i} style={{
              width: 40, height: 48, borderRadius: 10,
              border: `2.5px solid ${showResult ? (isCorrect ? '#2ECC71' : '#E74C3C') : P.ink}`,
              background: letter ? '#E8F4FD' : '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 22, fontWeight: 800, color: P.ink, fontFamily: FONT,
              boxShadow: `0 3px 0 ${showResult ? (isCorrect ? '#27AE60' : '#C0392B') : P.ink}`,
            }}>
              {letter.toUpperCase()}
            </div>
          );
        })}
      </div>

      {/* Letter pool */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
        {(prompt.scrambled || []).map((letter, idx) => {
          const isUsed = !availableIndices.includes(idx);
          return (
            <button key={idx} onClick={() => handleLetterClick(idx)}
              disabled={disabled || showResult || isUsed}
              style={{
                width: 42, height: 42, borderRadius: 10,
                border: `2.5px solid ${P.ink}`,
                boxShadow: isUsed ? 'none' : `0 3px 0 ${P.ink}`,
                background: isUsed ? '#eee' : P.sand,
                color: isUsed ? '#ccc' : P.ink,
                fontSize: 20, fontWeight: 800, fontFamily: FONT,
                cursor: disabled || showResult || isUsed ? 'default' : 'pointer',
                transition: 'all 0.1s',
              }}>
              {letter.toUpperCase()}
            </button>
          );
        })}
      </div>

      {showResult && (
        <div style={{ fontSize: 20, fontWeight: 800, color: isCorrect ? '#2ECC71' : '#E74C3C' }}>
          {isCorrect ? '✓ Đúng rồi!' : `✗ Đáp án: ${answer}`}
        </div>
      )}
    </div>
  );
}
